import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col, Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from 'moment';

function ListadoNotasCxP() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_COMPRAS_ACUMULADOS = process.env.REACT_APP_URL_COMPRAS_ACUMULADOS;
  const URL_TELAS_OC = process.env.REACT_APP_URL_TELAS_OC;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;

    let hoy = new Date()
    let inicio = new Date()
    inicio.setDate(inicio.getDate()-30);
   
    let endDate   = moment(hoy).format("YYYY-MM-DD"); 
    let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [compras, setCompras] = useState([]);
  const [telasOC, setTelasOC] = useState([]);
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOrden, setSelectedOrden] = useState("");
  const [articulos, setArticulos] = useState([]);
  
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedImpuestos, setSelectedImpuestos] = useState("");

  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  
  const [fecha, setFecha] = useState("");
  const [factura_proveedor, setFacturaProveedor] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [contenedor, setContenedor] = useState("");
  const [pais_origen, setPaisOrigen] = useState("");
  const [numero_compra, setNumeroCompra] = useState("");
  const [piezas, setPiezas] = useState("");
  const [idEdit, setIdEdit] = useState("");
  const [selectedProveedorEdit, setSelectedProveedorEdit] = useState("");

  const [articulosCompra, setArticulosCompra] = useState([]);
 

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_NOTAS_CXP}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCompras = response.data;
        // Array para pagination
        let arrayTabla = allCompras
          .sort((a, b) => (a.idNotasCxP > b.idNotasCxP ? 1 : -1))
          .map((a) => {
            return {
              activo: a.is_active,
              _id: a._id,
              numero: "M " +a.idNotasCxP,
              fecha: a.fecha,
              totalCantidad: a.procesosEntrada[0].totalPiezas,
              totalPiezasSegundas: a.procesosEntrada[0].totalPiezasSegundas,
              numeroOrden: a.procesosEntrada[0].idProcesosEntrada,
              // fecha_orden_compra: a.procesosEntrada[0].fecha,
              proveedores: a.proveedores[0].nombre_comercial,
              idProveedores: a.proveedores[0]._id,
              idOrdenCompra: a.procesosEntrada[0]._id,
              total_costo: a.total_costo,
              subtotal: a.subtotal,
              iva: a.iva,
              saldo: a.saldo,
              precioUnitario: a.procesosEntrada[0].precio,
              abonos: parseFloat(a.total_costo) - parseFloat(a.saldo),
              articulo: a.procesosEntrada[0].pedidos[0].articulos[0].codigo,
              cliente: a.procesosEntrada[0].pedidos[0].clientes[0].nombre_comercial,
              factura: a.factura,
              empresas: a.empresas[0].name,
              idEmpresas: a.empresas[0]._id
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setCompras(allCompras);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresas = response.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const ListaCompras = comments.sort((a, b) =>
    a.idCompras > b.idCompras ? 1 : -1
  );

  function PDFTabla() {
    let totalCantidadPDF = 0;
    let totalPiezasSegundasPDF = 0;
    let totalCostoPDF = 0;
    let totalSubTotalPDF = 0;
    let totalIvaPDF = 0;
    let totalAbonosPDF = 0;
    let totalSaldoPDF = 0;
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedEmpresa == 0 || selectedEmpresa == a.idEmpresas) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)&& // Asegurando que el elemento esté activo
        (
          (selectedImpuestos == "Si" && a.iva > 0) || // Si selecciona "Si", verificar si los impuestos son mayores o iguales a 0
          (selectedImpuestos == "No" && a.iva == 0) || // Si selecciona "No", verificar si los impuestos son exactamente 0
          selectedImpuestos == "" // Para la opción "Todos", no aplicar un filtro específico de impuestos
        )
      ) {
      totalCantidadPDF = totalCantidadPDF + a.totalCantidad;
      totalPiezasSegundasPDF = totalPiezasSegundasPDF + a.totalPiezasSegundas;
      totalCostoPDF = totalCostoPDF + a.total_costo;
      totalSubTotalPDF = totalSubTotalPDF + a.subtotal;
      totalIvaPDF = totalIvaPDF + a.iva;
      totalAbonosPDF = totalAbonosPDF + a.abonos;
      totalSaldoPDF = totalSaldoPDF + a.saldo;
        return [
          a.numero,
          a.fecha,
          a.empresas,
          a.factura,
          a.proveedores,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
          new Intl.NumberFormat("en-US").format(a.totalPiezasSegundas),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subtotal),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_costo),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text(`Facturas Maquilas`, 20, 30);
    doc.text(`Desde:${selectedFechaInicio} Hasta: ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Empresa",
          "Factura",
          "Proveedor",
          "Cantidad",
          "Segundas",
          "Subtotal",
          "IVA",
          "Costo Total",
          "Abonos",
          "Saldo"
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(totalCantidadPDF),
          new Intl.NumberFormat("en-US").format(totalPiezasSegundasPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSubTotalPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIvaPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCostoPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldoPDF),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`Compras.pdf`);
  }

  function excel() {
    const dataExcel = ListaCompras.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedEmpresa == 0 || selectedEmpresa == a.idEmpresas) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)&& // Asegurando que el elemento esté activo
        (
          (selectedImpuestos == "Si" && a.iva > 0) || // Si selecciona "Si", verificar si los impuestos son mayores o iguales a 0
          (selectedImpuestos == "No" && a.iva == 0) || // Si selecciona "No", verificar si los impuestos son exactamente 0
          selectedImpuestos == "" // Para la opción "Todos", no aplicar un filtro específico de impuestos
        )
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Empresa: a.empresas,
          Entrada: a.numeroOrden,
          Proveedores: a.proveedores,
          Cantidad: a.totalCantidad,
          Segundas: a.totalPiezasSegundas,
          Subtotal: a.subtotal,
          IVA: a.iva,
          Costo: a.total_costo,
          Abonos: a.abonos,
          Saldo: a.saldo
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoNotas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoNotas",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Empresa",
          "Entrada",
          "Proveedores",
          "Cantidad",
          "Segundas",
          "Subtotal",
          "IVA",
          "Costo",
          "Abonos",
          "Saldo"
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Empresa",
          "Entrada",
          "Proveedores",
          "Cantidad",
          "Segundas",
          "Subtotal",
          "IVA",
          "Costo",
          "Abonos",
          "Saldo"
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let totalCantidadPDF = 0;
    let totalCostoPDF = 0;
    let totalAbonosPDF = 0;
    let totalSaldoPDF = 0;
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedEmpresa == 0 || selectedEmpresa == a.idEmpresas) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)&& // Asegurando que el elemento esté activo
        (
          (selectedImpuestos == "Si" && a.iva > 0) || // Si selecciona "Si", verificar si los impuestos son mayores o iguales a 0
          (selectedImpuestos == "No" && a.iva == 0) || // Si selecciona "No", verificar si los impuestos son exactamente 0
          selectedImpuestos == "" // Para la opción "Todos", no aplicar un filtro específico de impuestos
        )
      ) {
      totalCantidadPDF = totalCantidadPDF + a.totalCantidad;
      totalCostoPDF = totalCostoPDF + a.total_costo;
      totalAbonosPDF = totalAbonosPDF + a.abonos;
      totalSaldoPDF = totalSaldoPDF + a.saldo;
        return [
          a.numero,
          a.fecha,
          a.empresas,
          a.numeroOrden,
          a.proveedores,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_costo),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text(`Notas Maquileros`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Empresa",
          "Entrada",
          "Proveedor",
          "Cantidad",
          "Costo Total",
          "Abonos",
          "Saldo"
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(totalCantidadPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCostoPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldoPDF),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Notas Maquileros",
          email: mailTo,
          fileName: "ListadoNotas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Notas Maquileros.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    factura_proveedor,
    observaciones,
    contenedor,
    numero,
    pais_origen,
    idEdit
  ) {
    setFecha(fecha);
    setFacturaProveedor(factura_proveedor);
    setObservaciones(observaciones);
    setContenedor(contenedor)
    setNumeroCompra(numero);
    setPaisOrigen(pais_origen);
    setIdEdit(idEdit);
    toggleEdit();
  }

  async function PDFOC(
    fecha,
    idProveedores,
    proveedores,
    totalCantidad,
    totalPiezasSegundas,
    observaciones,
    contenedor,
    numero,
    idPDFOC
  ) {
    await axios
      .get(`${URL_INVENTARIOS_TELAS}/compras/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosCompra = response.data;
        let arrayTabla = allArticulosCompra
        .sort((a, b) => (a.captura > b.captura ? 1 : -1))
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].codigo + " " + a.articulos[0].descripcion,
              unidad: a.articulos[0].unidad,
              colores: a.colores[0].name,
              cantidad: a.cantidad,
              precio: a.telasOC[0].precio,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        let piezas = dataFinal.length

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);


        let total_importe = 0;
        const data = dataFinal.map((a) => {
            total_importe = total_importe + a.precio * a.cantidad;
            return [
              a.articulos,
              a.unidad,
              a.colores,
              new Intl.NumberFormat("en-US").format(a.cantidad),
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precio),
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precio * a.cantidad),
            ]
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape");
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 140, 15, 25, 25);
        doc.text(`Compra # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Proveedor ${proveedores} / Contenedor ${contenedor}`, 20, 30);
        doc.text(
          `Piezas ${new Intl.NumberFormat("en-US").format(totalCantidad)} / Segundas ${new Intl.NumberFormat("en-US").format(totalPiezasSegundas)} / Modelos ${piezas}`,
          20,
          35
        );
        doc.autoTable({
          head: [
            ["Articulo", "Unidad", "Color", "Cantidad", "Segundas", "Precio", "Total"],
          ],
          body: dataPDFLimpia,
          startY: 45,
          foot: [
            [
              "",
              "",
              "Totales",
              new Intl.NumberFormat("en-US").format(totalCantidad),
              new Intl.NumberFormat("en-US").format(totalPiezasSegundas),
              "",
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total_importe),
            ],
          ],
          showFoot: "lastPage",
        });
        doc.save(`Compra-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function editCompras(event) {
    event.preventDefault();
    const URL_COMPRA_EDIT = `${process.env.REACT_APP_URL_COMPRAS}/${idEdit}`;
    axios
      .all([
        axios.patch(
          URL_COMPRA_EDIT,
          {
            fecha,
            factura_proveedor,
            observaciones,
            contenedor,
            pais_origen,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Compra",
            detalle: `${numero_compra} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Empresa", field: "empresas", sortable: true },
    { name: "Entrada", field: "numeroOrden", sortable: true },
    { name: "Factura", field: "factura", sortable: true },
    { name: "Maquilero", field: "proveedores", sortable: true },
    { name: "Articulo", field: "articulo", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Cantidad", field: "totalCantidad", sortable: true },
    { name: "Segundas", field: "totalPiezasSegundas", sortable: true },
    { name: "Precio", field: "precioUnitario", sortable: true },
    { name: "Subtotal", field: "subtotal", sortable: true },
    { name: "IVA", field: "iva", sortable: true },
    { name: "Costo Total", field: "total_costo", sortable: true },
    { name: "Abonos", field: "abonos", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    // { name: "PDF", field: "PDF", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.empresas.toLowerCase().includes(search.toLowerCase()) ||
          comment.articulo.toLowerCase().includes(search.toLowerCase()) ||
          comment.factura.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroOrden.toString().includes(search)||
          comment.totalCantidad.toString().includes(search)||
          comment.totalPiezasSegundas.toString().includes(search)||
          comment.numero.toString().includes(search) ||
          comment.subtotal.toString().includes(search)||
          comment.precioUnitario.toString().includes(search)||
          comment.iva.toString().includes(search)||
          comment.total_costo.toString().includes(search)||
          comment.abonos.toString().includes(search)||
          comment.saldo.toString().includes(search)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedores.includes(selectedProveedor)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    if (selectedImpuestos == "Si") {
      computedComments = computedComments.filter(
        (e) => e.iva > 0
      );
    }
    if (selectedImpuestos == "No") {
      computedComments = computedComments.filter(
        (e) => e.iva == 0
      );
    }
        if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        e.idEmpresas.includes(selectedEmpresa)
      );
    }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "totalCantidad" &&
      sorting.field != "totalPiezasSegundas" &&
      sorting.field != "precioUnitario" &&
      sorting.field != "numeroOrden" &&
      sorting.field != "numero" &&
      sorting.field != "subtotal" &&
      sorting.field != "iva" &&
      sorting.field != "total_costo" &&
      sorting.field != "abonos" &&
      sorting.field != "saldo"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field == "totalPiezasSegundas" ||
        sorting.field == "precioUnitario" ||
        sorting.field == "numeroOrden" ||
        sorting.field == "numero" ||
        sorting.field == "subtotal" ||
        sorting.field == "iva" ||
        sorting.field != "total_costo" ||
        sorting.field != "abonos" ||
        sorting.field != "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field == "totalPiezasSegundas" ||
        sorting.field == "precioUnitario" ||
        sorting.field == "numeroOrden" ||
        sorting.field == "numero" ||
        sorting.field == "subtotal" ||
        sorting.field == "iva" ||
        sorting.field != "total_costo" ||
        sorting.field != "abonos" ||
        sorting.field != "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedProveedor,
    selectedFechaInicio,
    selectedFechaFin,
    selectedImpuestos,
    selectedEmpresa
  ]);

  let totalCantidadTabla = 0;
  let totalPiezasSegundasTabla = 0;
  let totalCostoTabla = 0;
  let totalSubtotalTabla = 0;
  let totalIvaTabla = 0;
  let totalAbonosTabla = 0;
  let totalSaldoTabla = 0;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_adminCxP ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCXP"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Notas Maquileros</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Notas Maquileros</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Proveedores</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {proveedores
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                  )
                  .map((a) => {
                    if (a.tipo == "Maquilero") {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    }
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Impuestos</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedImpuestos}
                onChange={(e) => {
                  setSelectedImpuestos(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Sí</option>
                <option value="No">No</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Empresa</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedEmpresa}
                onChange={(e) => {
                  setSelectedEmpresa(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {empresas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                totalCantidadTabla = totalCantidadTabla + a.totalCantidad;
                totalPiezasSegundasTabla =
                  totalPiezasSegundasTabla + a.totalPiezasSegundas;
                totalCostoTabla = totalCostoTabla + a.total_costo;
                totalSubtotalTabla = totalSubtotalTabla + a.subtotal;
                totalIvaTabla = totalIvaTabla + a.iva;
                totalAbonosTabla = totalAbonosTabla + a.abonos;
                totalSaldoTabla = totalSaldoTabla + a.saldo;
                {
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.empresas}</td>
                      <td>{a.numeroOrden}</td>
                      <td>{a.factura}</td>
                      <td>{a.proveedores}</td>
                      <td>{a.articulo}</td>
                      <td>{a.cliente}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.totalCantidad)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.totalPiezasSegundas,
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.precioUnitario)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.subtotal)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.iva)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total_costo)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.abonos)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.saldo)}
                      </td>
                      {/* <td>
                          <div>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.idProveedores,
                                  a.proveedores,
                                  a.totalCantidad,
                                  a.observaciones,
                                  a.contenedor,
                                  a.numero,
                                  a._id
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                          </div>
                      </td> */}
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTALES
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalCantidadTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(
                    totalPiezasSegundasTabla,
                  )}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalSubtotalTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalIvaTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalCostoTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalAbonosTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalSaldoTabla)}
                </td>
                {/* <td></td> */}
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {loader}
    </>
  );
}

export default ListadoNotasCxP;
